/**
 * Resolve an asset path returned by the API (e.g. ``uploads/listings/foo.jpg``)
 * into a URL the browser can actually load.
 *
 * In dev the Vite proxy forwards ``/uploads/*`` to the backend on the same
 * origin, so a relative path is enough. In production the SPA is served on
 * ``redevicer.com`` while uploads live on ``api.redevicer.com`` — we need the
 * absolute API origin or the WWW server returns the SPA index.html instead of
 * the image, which is exactly what was happening before this change.
 */
const API_BASE = import.meta.env.VITE_API_BASE ?? '/api'

function apiOrigin(): string {
  // "/api" → "" (same-origin in dev — Vite proxy handles /uploads)
  // "https://api.redevicer.com/api" → "https://api.redevicer.com"
  return API_BASE.replace(/\/api\/?$/i, '')
}

export function publicAssetUrl(path: string): string {
  if (!path) return ''
  if (
    path.startsWith('blob:') ||
    path.startsWith('data:') ||
    path.startsWith('http://') ||
    path.startsWith('https://')
  ) {
    return path
  }
  const p = path.startsWith('/') ? path : `/${path}`
  return `${apiOrigin()}${p}`
}
